// extracted by mini-css-extract-plugin
export default {"statusBar":"ShipmentStatusBar_statusBar__-1CTe","status":"ShipmentStatusBar_status__hMmEW"};